import {KBSearch} from "../Components/KBSearch";
import {Route, Routes as BrowserRoutes} from "react-router-dom"
import {Drugs} from "../Components/Drugs";
import {KBStats} from "../Components/KBStats";
import {useEffect, useState} from "react";
import {getKBStats} from "../Utils/api";
import {DrugDetails} from "../Components/DrugDetails";
import {Diseases} from "../Components/Diseases";
import {DiseaseDetails} from "../Components/DiseaseDetails";
import {Genes} from "../Components/Genes";
import {GeneDetails} from "../Components/GeneDetails";
import {RNA} from "../Components/RNA";
import {RNADetails} from "../Components/RNADetails";
import {PDBs} from "../Components/PDBs";
import {PDBDetails} from "../Components/PDBDetails";
import {DrugDisease} from "../Components/DrugDisease";
import {DrugDiseaseDetails} from "../Components/DrugDiseaseDetails";
import {DrugPDB} from "../Components/DrugPDB";
import {DrugPDBDetails} from "../Components/DrugPDBDetails";
import {DiseaseGene} from "../Components/DiseaseGene";
import {DiseaseGeneDetails} from "../Components/DiseaseGeneDetails";
import {DiseaseMiRNA} from "../Components/DiseaseMiRNA";
import {DiseaseMiRNADetails} from "../Components/DiseaseMiRNADetails";
import {LncRNA} from "../Components/LncRNA";
import {DiseaseLncRNADetails} from "../Components/DiseaseLncRNADetails";
import {LncRNADetails} from "../Components/LncRNADetails";
import {DiseaseLncRNA} from "../Components/DiseaseLncRNA";
import {AlternateMedicine} from "../Components/AlternateMedicine";
import {AlternateMedicineDetails} from "../Components/AlternateMedicineDetails";

export const Main1 = () => {

  const [isKBLoading, setIsKBLoading] = useState(false)
  const [kbData, setKbData] = useState(false)


  useEffect(() => {
    setIsKBLoading(true)
    getKBStats()
      .then(r => setKbData(r.data))
      .then(_ => setIsKBLoading(false))
  }, [])

  return(
    <>
      <KBSearch />
      <div className="container">
        <BrowserRoutes>
          <Route path="/" element={<KBStats kbData={kbData} isKBLoading={isKBLoading} />} />
          <Route path="/drugs" element={<Drugs total={kbData.drugs} />} />
          <Route path="/alternateMedicine" element={<AlternateMedicine total={kbData.alternateMedicine} />} />
          <Route path="/diseases" element={<Diseases total={kbData.diseases} />} />
          <Route path="/genes" element={<Genes total={kbData.genes} />} />
          <Route path="/miRNAs" element={<RNA total={kbData.miRNAs} />} />
          <Route path="/lncRNAs" element={<LncRNA total={kbData.lncRNAs} />} />
          <Route path="/PDBs" element={<PDBs total={kbData.PDBs} />} />
          <Route path="/drug-disease" element={<DrugDisease total={kbData.drugDiseasePairs} />} />
          <Route path="/drug-PDB" element={<DrugPDB total={kbData.drugPDBPairs} />} />
          <Route path="/disease-gene" element={<DiseaseGene total={kbData.diseaseGenePairs} />} />
          <Route path="/disease-miRNA" element={<DiseaseMiRNA total={kbData.diseaseMiRNAPairs} />} />
          <Route path="/disease-lncRNA" element={<DiseaseLncRNA total={kbData.diseaseLncRNAPairs} />} />
          <Route path="/PDBs/:PDB" element={<PDBDetails />} />
          <Route path="/miRNAs/:miRNA" element={<RNADetails />} />
          <Route path="/lncRNAs/:lncRNA" element={<LncRNADetails />} />
          <Route path="/genes/:gene" element={<GeneDetails />} />
          <Route path="/drugs/:drug" element={<DrugDetails />} />} />
          <Route path="/alternateMedicine/:alternateMedicine" element={<AlternateMedicineDetails />} />} />
          <Route path="/diseases/:disease" element={<DiseaseDetails />} />} />
          <Route path="/drug-disease/:item" element={<DrugDiseaseDetails />} />
          <Route path="/drug-PDB/:item" element={<DrugPDBDetails />} />
          <Route path="/disease-gene/:item" element={<DiseaseGeneDetails />} />
          <Route path="/disease-miRNA/:item" element={<DiseaseMiRNADetails />} />
          <Route path="/disease-lncRNA/:item" element={<DiseaseLncRNADetails />} />
        </BrowserRoutes>
      </div>
    </>
  )
}